import { render, staticRenderFns } from "./b-dropdown.vue?vue&type=template&id=2725599e&scoped=true"
import script from "./b-dropdown.vue?vue&type=script&lang=js"
export * from "./b-dropdown.vue?vue&type=script&lang=js"
import style0 from "./b-dropdown.vue?vue&type=style&index=0&id=2725599e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2725599e",
  null
  
)

export default component.exports